'use strict';

/**
 * @ngdoc function
 * @name gfcmsApp.controller:NewuserCtrl
 * @description
 * # NewuserCtrl
 * Controller of the gfcmsApp
 */
angular.module('gfcmsApp')
  .controller('NewuserCtrl', function($location, $routeParams, $controller, userService, FlashService, cfpLoadingBar) {

    var newUserVm = this;
    $controller('BaseController', {
      vm: newUserVm
    });
    var userId = $routeParams.userId;

    newUserVm.isExistingUser = !!userId;
    newUserVm.userData = {
      firstName: null,
      lastName: null,
      nickname: null,
      password: null,
      confirmPassword: null,
      roles: []
    };

    newUserVm.userRoles = [];
    newUserVm.submit = submit;

    newUserVm.baseActivate(activate);

    function activate() {
      var rolesRequest = newUserVm.requestStart()
        .then(userService.getRoles)
        .then(function(response) {
          newUserVm.userRoles = response;
        });

      if (newUserVm.isExistingUser) {
        rolesRequest = rolesRequest
          .then(userService.GetById.bind(null, userId))
          .then(function(response) {
            newUserVm.userData = response;

            for (var i = 0; i < newUserVm.userRoles.length; i++) {
              var roleIndex = newUserVm.userData.roles.indexOf(newUserVm.userRoles[i].id);
              newUserVm.userRoles[i].selected = roleIndex > -1;
            }
          });
      }

      rolesRequest
        .finally(newUserVm.requestComplete.bind(newUserVm));

    }

    function submit(valid) {
      if (valid) {
        newUserVm.userData.roles = newUserVm.userRoles.reduce(function(result, item) {
          if (item.selected) {
            result.push(item.id);
          }

          return result;
        }, []);

        var saveUser = newUserVm.isExistingUser ? updateUser : createUser;

        newUserVm.requestStart()
          .then(saveUser)
          .finally(newUserVm.requestComplete.bind(newUserVm));
      }
    }

    function createUser() {
      return userService.createUser(newUserVm.userData)
      .then(function() {
        FlashService.Success('User created');
        $location.path('/users');
      });
    }

    function updateUser() {
      return userService.Update(newUserVm.userData)
      .then(function() {
        FlashService.Success('User updated');
        $location.path('/users');
      });
    }
  });
